import styled from "styled-components";

const Heading = styled.h4`
  font-weight: 600;
  font-size: 2.25rem;
  color: ${(props) => props.color || "var(--font1)"};
  margin-bottom: ${(props) => props.margin || "2.4rem"};
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export default Heading;
